import { createAction } from '@reduxjs/toolkit';

export const FETCH_BANK_ACCOUNTS_STORE_KEY = 'BANK_ACCOUNTS/FETCH_BANK_ACCOUNTS';

export const fetchBankAccountsRequested = createAction(`${FETCH_BANK_ACCOUNTS_STORE_KEY}_API_REQUESTED`);
export const fetchBankAccountsSuccess = createAction(`${FETCH_BANK_ACCOUNTS_STORE_KEY}_API_SUCCESS`);
export const fetchBankAccountsFailed = createAction<string>(`${FETCH_BANK_ACCOUNTS_STORE_KEY}_API_FAILED`);
